import { ListLayout } from "../../../layouts";
import { DataGrid, Dialog, DialogContent } from "../../../components";
import { PermisoesHelper } from "../../../helpers";
import { useEffect, useState } from "react";
import AddRotas from "../addRotas/addRotas.view";
import { notification } from "../../../services";
import RotaService from "../../../services/api/rota.service";
import { responseErros } from "../../../utils";

const ListRotasView = () => {
  const [id, setId] = useState(false);
  const [rotas, setRotas] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const permissoesHelper = new PermisoesHelper();
  const rotaService = new RotaService();

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Descrição da Rota",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaRotas();
  }, []);

  const buscaRotas = async function (filter) {
    setLoading(true);
    const result = await rotaService.getAll(filter);
    if (!result.isAxiosError) {
      setRotas(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const sendServerDatagrid = (props) => {
    buscaRotas(props.filtros);
  };

  const onClickDeleteRota = async function (id) {
    const rota = rotas.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir a rota ${rota.descricao}?`
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await rotaService.deletar(id);
      if (!result.isAxiosError) {
        buscaRotas();
        notification.deletadoSucesso();
      } else {
        responseErros(result);
      }
      setLoading(false);
    }
  };

  return (
    <ListLayout
      title="Rotas"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao(
        "meios-pagamento-cadastrar"
      )}
    >
      <DataGrid
        rows={rotas}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={onClickDeleteRota}
        visualizarShow={permissoesHelper.temPermisao("rotas-visualizar")}
        editShow={permissoesHelper.temPermisao("rotas-editar")}
        deleteShow={permissoesHelper.temPermisao("rotas-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        PaperComponent="div"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <AddRotas
            id={id}
            handleCloseDialog={handleCloseDialog}
            buscaRotas={buscaRotas}
            openDialog={openDialog}
          />
        </DialogContent>
      </Dialog>
    </ListLayout>
  );
};

export default ListRotasView;
